export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));
    if (user && user.result[0].accessToken ) {
      return { Authorization: 'Bearer ' + user.result[0].accessToken };
    } else {
      return {};
    }
  }
  